export default __webpack_public_path__ + "static/cruiselines-vrc-places-4-111968378cfc6ab6f679a841d04b06b4.jpg";